import { createContext, useState, useContext, useMemo } from "react";

const LayoutContext = createContext();

export const LayoutProvider = ({ children }) => {
  const [headerContent, setHeaderContent] = useState(null);
  const [footerContent, setFooterContent] = useState(null);
  const [showHeader, setShowHeader] = useState(true);
  const [showFooter, setShowFooter] = useState(true);

  const value = useMemo(
    () => ({
      headerContent,
      setHeaderContent,
      footerContent,
      setFooterContent,
      showHeader,
      setShowHeader,
      showFooter,
      setShowFooter,
    }),
    [headerContent, footerContent, showHeader, showFooter]
  );

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
};

export const useLayout = () => useContext(LayoutContext);
